var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutGenerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7365 36C28.6776 36 36.7365 27.9411 36.7365 18C36.7365 8.05888 28.6776 0 18.7365 0C8.79532 0 0.73645 8.05888 0.73645 18C0.73645 27.9411 8.79532 36 18.7365 36Z",
    fill: "#E1EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4864 24.4333H12.4864V14.25H18.3198V12.5833H12.4864C11.5698 12.5833 10.8198 13.3333 10.8198 14.25V24.25C10.8198 25.1667 11.5698 25.9167 12.4864 25.9167H22.4864C23.4031 25.9167 24.1531 25.1667 24.1531 24.25V18.4167H22.4864V24.4333Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8198 15.9167H14.1531V17.5833H20.8198V15.9167Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1531 18.4167V20.0833H20.8198V18.4167H14.1531Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8198 20.9167H14.1531V22.5833H20.8198V20.9167Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7891 10.9565L25.3868 10.0833L24.9983 10.9565L24.1252 11.3451L24.9983 11.7474L25.3868 12.6114L25.7891 11.7474L26.6531 11.3451L25.7891 10.9565Z",
    fill: "#1570EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5299 11.015L21.7437 12.7521L20.0019 13.543L21.7437 14.3339L22.5299 16.0709L23.3208 14.3339L25.0625 13.543L23.3208 12.7521L22.5299 11.015Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutGenerator);
export default __webpack_public_path__ + "static/media/AboutGenerator.70e60deb1632430a00f46299dbf3f734.svg";
export { ForwardRef as ReactComponent };